import * as d3 from 'd3'

// import Overlay from 'ol/Overlay'
import { fromLonLat } from 'ol/proj'
import * as topojson from 'topojson-client'

export function addD3Style(minimapId, topoString, jsonStyle) {
  const rowIndex = minimapId.slice(7, -2);
  const whichOne = minimapId.slice(-1);

  // D3 geometry is loaded here
  const topoCollection = JSON.parse(topoString);
  const dataProj = topoCollection.crs.properties.name;
  // convert TopoJSON to GeoJSON, https://github.com/topojson/topojson
  const collection = topojson.feature(topoCollection, topoCollection.objects.collection);

  // create d3 container that will be linked to the minimap as overlay
  // const div = document.createElement('div');
  const d3divId = 'miniD3-' + rowIndex + '_' + whichOne;
  // div.id = d3divId;
  // div.className = 'miniD3 miniD3-' + rowIndex;

  // document.getElementById(minimapId).appendChild(div);
  // const overlay = new Overlay({
  //   id: 'd3',
  //   // element: div, // div element disappears from DOM if I link it to overlay
  //   position: map.getView().getCenter(),
  //   positioning: 'center-center',
  //   stopEvent: false
  // });
  // map.addLayer(overlay);
  // console.log('Overlay added to minimap');
  // console.log(map.getLayers().getArray()[2].getProperties());

  setUpMiniD3(d3divId, minimapId);
  addD3geometry(d3divId, minimapId, jsonStyle.geom_type, collection);
  applyD3Style(d3divId, jsonStyle);
}

function setUpMiniD3(d3divId, minimapId, d3div) {
  // console.log('setUpMiniD3');
  const miniD3 = d3.select('#' + minimapId).select('div.ol-viewport').append('div')
    .attr('id', d3divId).attr('class', 'miniD3');
  // console.log(miniD3[0][0]);
  const svg = miniD3.append('svg');
  const g = svg.append('g').attr('id', d3divId + '_g'); // group

  // const defs = svg.append('defs');
  //
  // // markers.js
  // // Add markers that are used in CSS styles
  // addMarkers(defs);
}

function addD3geometry(d3divId, minimapId, geoType, collection) {
  // console.log('addD3geometry', collection);
  const map = document.getElementById(minimapId).data;
  let currentProjection = map.getView().getProjection();
  //get the vector layer div element
  const d3div = d3.select('#' + d3divId);
  // const findit = document.getElementById(d3divId);
  // console.log(d3div, findit);

  const svg = d3div.select('svg');
  const g = d3.select('#' + d3divId + '_g');
  // Remove old SVG object
  g.select('path').remove();
  const bounds = d3.geoBounds(collection);
  const projection = d3.geoTransform({ point: function(x, y) {
    const pp = project([x, y]);
    return this.stream.point(pp[0], pp[1]);
  }});
  const path = d3.geoPath(projection);
  const feature = g.selectAll('path')
    .data(collection.features)
    .enter().append('path');
  // map.once('postrender', function() {
  map.on('postrender', () => {
    // safe to call map.getPixelFromCoordinate from now on
    if (!map.getView().getInteracting() && !map.getView().getAnimating()) {
      // console.log('it means map is loading new tiles of WMTS, no need to reset svg');
    } else {
      // console.log('redraw minisvg');
      reset();
    }
  });
  map.on('moveend', () => { // need it after manual js zoom to largest feature
    reset();
  });

  function reset() {
    // console.log('reset');
    currentProjection = map.getView().getProjection();
    // const oldbounds = path.bounds(collection); // already projected
    // We add buffer so that features do not get clipped at bounds
    const slideSVGWindowSize = 10;
    const bufferSize = slideSVGWindowSize * 2;

    const bottomLeft = project(bounds[0]),
            topRight = project(bounds[1]);
    const wider = [bottomLeft[0] - slideSVGWindowSize, topRight[1] - slideSVGWindowSize];

    svg.attr('width', topRight[0] - bottomLeft[0] + bufferSize)
        .attr('height', bottomLeft[1] - topRight[1] + bufferSize)
        .style('left', wider[0] + 'px')
        .style('top', wider[1] + 'px');

    // // Translate the entire SVG layer
    g.attr('transform', 'translate(' + -wider[0] + ',' + -wider[1] + ')');

    feature.attr('d', path);

    addSymbolsAlongPath(d3divId);
  }
  function project(x) {
    return map.getPixelFromCoordinate(fromLonLat(x, currentProjection));
  }
}

function applyD3Style(d3divId, layerStyle) {
  // if ( debug < 7 ) { console.log('applyD3Style', d3divId, layerStyle); }
  const layerId = layerStyle.layerid;
  const d3div = d3.select('#' + d3divId);
  d3div.select('path')
  .attr('class', function(d) {
    // check if this object is active or not
    if (d.properties[layerStyle.styleAttributeDelete] === 1 ||
        d.properties[layerStyle.styleAttributeDelete] === '1') {
      // return one common style for ghost features
      // return 'deleteLineObject'; // white
      return 'ghostLine'; // neutral colour
    } else {
      // return the correct style based on layer id and attribute value
      if (layerStyle.styleAttribute === '') {
        if (this.getTotalLength() > 40) {
          return layerId
        } else {
          return layerId + '_no_arrow';
        }
        return layerId
      } else {
        if (d.properties[layerStyle.styleAttribute] === null) {
          return layerId + '_' + layerStyle.styleAttribute + '_0';
        } else {
          return layerId + '_' + layerStyle.styleAttribute + '_' + d.properties[layerStyle.styleAttribute];
        }
      }
    }
  }) // CSS class for polygons with no style
  .style('marker-end', function(d) {
    if (d.properties[layerStyle.styleAttributeDelete] === '1') {
      if (this.getTotalLength() > 40) {
        return 'url(#deleteLineObject-end)';
      } else {
        return '';
      }
    } else if (layerStyle.styleAttribute === '') {
      if (this.getTotalLength() > 40) {
        return 'url(#arrow-end)';
      } else {
        return '';
      }
    } else {
      return '';
    }
  })
  .style('marker-start', function(d) {
    if (d.properties[layerStyle.styleAttributeDelete] === '1') {
      if (this.getTotalLength() > 40) {
        return 'url(#deleteLineObject-start)';
      } else {
        return '';
      }
    } else if (layerStyle.styleAttribute === '') {
      if (this.getTotalLength() > 40) {
        return 'url(#arrow-start)';
      } else {
        return '';
      }
    } else {
      return '';
    }
  });
}

function addSymbolsAlongPath(d3divId) {
  const d3div = d3.select('#' + d3divId);

  // Remove old circles and polylines and redraw them if necessary
  const c = d3div.selectAll('circle');
  const p = d3div.selectAll('polyline');
  c.remove();
  p.remove();

  for (let at = 1; at <= 4; at++) {
    const cn = 'RAN_L_anleggstype_' + at;
    const path = d3div._groups[0][0].getElementsByClassName(cn)[0];
    if (!path) { continue; }
    const totalLength = path.getTotalLength();
    const spacing = 20 * ((at + 1) % 2 + 1);
    const start = (spacing + totalLength % spacing) / 2;
    if (totalLength >= 2 * spacing) {
      for (let i = start; i <= totalLength - start / 2; i += spacing) {
        const myPoint = path.getPointAtLength(i);
        const x = myPoint.x, y = myPoint.y;
        if (at === 1 || at === 2) {
          // 1: Sperregjerde, draw circles along line
          // 2: Midlertidig sperregjerde, draw circles along line
          d3div.select('g').append('svg:circle')
            .attr('cx', x)
            .attr('cy', y)
            .style('stroke', 'black')
            .style('fill', 'none')
            .attr('r', 4.5);
        }
        if (at === 3 || at === 4) {
          // 3: Beitehage, draw ticks along line
          // 4: Fangarm, draw triangle along line
          let pts;
          if (at === 3) {
            pts = [x, (y - 6), x, (y + 6)].join(',');
          }
          if (at === 4) {
            pts = [(x - 6), (y - 6), x, (y + 6), (x + 6), (y - 6)].join(',');
          }
          d3div.select('g').append('polyline')       // attach a polyline
            .style('stroke', 'black')   // colour the line
            .style('fill', 'none')      // remove any fill colour
            .style('stroke-width', 3)  // line width
            .style('stroke-linejoin', 'round')  // shape the line join
            .attr('points', pts);  // x,y points
        }
      }
    }
  }

}
